

























































































































import { Component, Prop, mixins } from 'nuxt-property-decorator'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import LightBox from 'vue-it-bigger'
import DefaultImage from '~/mixins/defaultImage'
import 'swiper/css/swiper.css'
import 'vue-it-bigger/dist/vue-it-bigger.min.css'

@Component({
  components: {
    Swiper,
    SwiperSlide,
    LightBox,
  },
  mixins: [DefaultImage],
})
export default class ImagesGallery extends mixins(DefaultImage) {
  @Prop({ default: [] }) images: Array<any>
  @Prop({ default: false }) showInformation: boolean
  @Prop({ default: true }) showFullGaleryButton: boolean

  currentSlideImage: number = 0
  placeHolderImage: string = '/placeholder.png'
  lightboxVisible: boolean = false
  lightboxIndex: number = 0
  options: any = {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    zoom: false,
  }

  get imagesCount() {
    return this.images.length
  }

  get lightboxImages(): Array<any> {
    return this.images
      .filter((image) => !this.isPdf(image.image || image.source || image))
      .map((image) => ({
        src: image.image || image.source || image,
        thumb: image.thumb || image.image || image,
      }))
  }

  get canShowFullGalleryButton(): boolean {
    return this.showFullGaleryButton && this.lightboxImages.length > 0
  }

  openLightbox(_index: number): void {
    this.lightboxIndex = this.currentSlideImage
    this.lightboxVisible = true
  }

  handleLightboxClose(): void {
    this.lightboxVisible = false
  }

  get swiper() {
    // @ts-ignore
    return this.$refs.consumerMapSwiper.$swiper
  }

  safeConcat(part1?: string, part2?: string): string {
    return (part1 ?? '') + (part2 ?? '')
  }

  isPdf(file: string): boolean {
    return file?.toLowerCase().endsWith('.pdf')
  }

  extractFileName(filePath: string): string {
    return filePath.split('/').pop() || 'View PDF'
  }
}
